/**
 * @enum {string}
 * @readonly
 */
export const ProductDocumentType = {
  MaterialSafetyDataSheet: 'materialSafetyDataSheet',
};
